import { Outlet } from 'react-router-dom';
import { createCustomerRoutes } from '@/core/router';
import { Header, Sidebar } from '@/shared/components/layout';
import { SidebarInset, SidebarProvider } from '@/shared/components/ui';

export function CustomerLayout() {
  const routes = createCustomerRoutes();

  return (
    <SidebarProvider>
      <Sidebar routes={routes} />
      <SidebarInset>
        <Header routes={routes} />
        <main className="flex flex-1 flex-col gap-4 p-6 pt-3 space-y-6 contain-paint">
          <div className="w-full max-w-full mx-auto pt-3 space-y-6">
            <Outlet />
          </div>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
